function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WhiteboardTool } from './WhiteboardTool';
export class SelectorTool extends WhiteboardTool {
  constructor(enableToolEvent, renderableModel, shadowEmitter, scope, selectElementsModel) {
    super(enableToolEvent, renderableModel, shadowEmitter, scope);
    _defineProperty(this, "elementModel", null);
    _defineProperty(this, "from", null);
    _defineProperty(this, "to", null);
    _defineProperty(this, "selectElementsModel", void 0);
    _defineProperty(this, "selectElements", new Map());
    _defineProperty(this, "showLiveCursor", false);
    this.selectElementsModel = selectElementsModel;
  }
  isSelectableItem(item) {
    return !!item.data.type && ['selector', 'eraser', 'laser'].indexOf(item.data.type) < 0 && item.data.role !== 'background';
  }
  onMouseDown(event) {
    this.from = null;
    this.to = null;
    if (this.elementModel) {
      this.elementModel.dispose();
    }
    this.elementModel = null;
    this.modelGetter().then(model => {
      if (model) {
        this.elementModel = model.createSelector();
        this.from = event.point.clone();
        this.to = event.point.clone();
        const rect = new this.scope.Rectangle(this.from, this.to);
        this.elementModel?.setPoints([rect.topLeft.x, rect.topLeft.y, rect.size.width, rect.size.height]);
      }
    });
    this.selectElements.clear();
  }
  onMouseDrag(event) {
    if (this.from && this.elementModel) {
      this.to = event.point.clone();
      const rect = new this.scope.Rectangle(this.from, this.to);
      this.elementModel.setPoints([rect.topLeft.x, rect.topLeft.y, rect.size.width, rect.size.height]);
      this.selectElementsModel.clearSelectElementForSelf();
      this.scope.project.activeLayer.children.forEach(item => {
        if (this.isSelectableItem(item)) {
          if (rect.contains(item.bounds)) {
            this.selectElements.set(item.data.uuid, item.data.ownerId);
          } else {
            this.selectElements.delete(item.data.uuid);
          }
        }
      });
    }
  }
  onMouseUp(event) {
    if (this.elementModel) {
      this.modelGetter().then(model => {
        if (model && this.elementModel) {
          model.removeElementItem(this.elementModel.uuid);
        }
      });
    }
    const elements = Array.from(this.selectElements.keys()).reduce((result, next) => {
      result.push({
        elementId: next,
        ownerId: this.selectElements.get(next)
      });
      return result;
    }, []);
    const hitResult = this.scope.project.hitTest(event.point);
    if (hitResult && hitResult.item.data.uuid && this.isSelectableItem(hitResult.item)) {
      elements.push({
        elementId: hitResult.item.data.uuid,
        ownerId: hitResult.item.data.ownerId
      });
    }
    this.selectElements.clear();
    this.selectElementsModel.addSelectElementForSelf(elements);
  }
}